/*
 * @Description: 数据大屏
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2023-08-18 14:26:28
 * @LastEditTime: 2023-08-21 11:20:03
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */

import {
  get
} from '../index'
export default {
  // 数据大屏
  dataScreen (querys) {
    return get('massage/admin/Admin/dataScreen', querys)
  },
  // 订单统计
  orderData (querys) {
    return get('massage/admin/Admin/orderData', querys)
  },
  // 求救通知
  policeList (querys) {
    return get('massage/admin/Admin/policeList', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/count.js